import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'

const ScheduledPostsTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/instagram/poster/{instaId}/scheduled-posts`,
  rowsPath: 'posts',
  rowClickable: true,
  attachPageId: false,
  replaceInstaId: true,
  columns: [
    {
      label: 'reply.post',
      field: 'image',
    },
    {
      label: 'reply.post',
      field: 'post',
    },

    {
      label: 'instagram.media-type',
      field: 'media_type',
    },
    {
      label: 'instagram.is_posted',
      field: 'is_posted',
    },
    {
      label: 'instagram.post-at',
      field: 'post_at',
    },
    {
      label: 'general.has-error',
      field: 'error',
    },
    {
      label: 'fields.created-at',
      field: 'created_at',
    },
    {
      label: 'forms.actions',
      field: 'actions',
    },
  ],
  paginationOptions: {
    enabled: false,
    perPage: 50,
    perPageOptions: [50, 100],
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
  ],
  filters: [
  ],
}

export default ScheduledPostsTableConfig
